import { mask } from "remask";

/**
 * Ex: 12345678901 => 123.456.789-01
 * @param value
 * @returns
 */
export const cpfFormat = (value: string) => {
  return value ? mask(value, '999.999.999-99') : '';
};

/**
 * Ex: 12345678901234 => 12.345.678/9012-34
 * @param value
 * @returns
 */
export const cnpjFormat = (value: string) => {
  return value ? mask(value, 'AA.AAA.AAA/AAAA-99') : '';
};
